<template>
  <div class="wrap1">
    <h1 class="common-title">
      <i class="el-icon-arrow-left" @click="$emit('doSubmit', null, 1)"></i>
      {{ type === 1 ? $t('543') : $t('833') }}
    </h1>
    <div class="wrap1-box wrap1-btn">
      <el-form ref="form" label-width="260px" :model="form" :rules="rules" label-position="right">
        <el-form-item :label="$t('545')" prop="name" key="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <!-- 选择人员 -->
        <el-form-item :label="$t('177')" prop="department_id" v-if="isDefault" key="department_id">
          <!-- 已选数量 -->
          <el-input
            @focus="orgVisible = true"
            :value="$t('912', { y: this.form.staff_info_ids.length || 0, x: this.form.department_id.length || 0 })"
          ></el-input>
          <framework
            v-if="orgVisible"
            @onConfirm="handleSelectDepart"
            :visible.sync="orgVisible"
            :defaultDepatment="form.department_list"
            :defaultEmployess="form.staff_list"
            :params="{ data_privilege: '1' }"
          />
        </el-form-item>
        <!-- 考勤组负责人 -->
        <el-form-item
          :label="$t('i18n.97e900aabe0246759d0e2705ab9e0620')"
          prop="supervisor_staff_ids"
          key="supervisor_staff_ids"
        >
          <template slot="label">
            <span style="vertical-align: middle">{{ $t('i18n.97e900aabe0246759d0e2705ab9e0620') }}</span>
            <el-tooltip effect="dark" :content="$t('i18n.b5c6695fd5a840eea446f5bf2ab0a307')" placement="top"
              ><i class="el-icon-warning-outline" />
            </el-tooltip>
          </template>
          <!-- 已选数量
            -->
          <el-input @focus="orgVisibleLead = true" :value="leadStaffList()"></el-input>
          <framework
            v-if="orgVisibleLead"
            @onConfirm="handleLeadDepart"
            :control="{ all: 1, depShow: 2, staffShow: 1, visible: true }"
            :visible.sync="orgVisibleLead"
            :defaultDepatment="[]"
            :defaultEmployess="form.supervisor_staff_list"
            :params="{ data_privilege: '1' }"
          />
        </el-form-item>
        <!-- 群组考勤规则 -->
        <el-form-item :label="$t('551')" prop="type" key="rules">
          <el-radio-group v-model="form.type" @change="changeRadio">
            <!-- 固定班制 -->
            <el-radio v-for="item in typeRules" :key="item.value" :label="item.value" class="my-radio">
              {{ $t(item.key) }}
              <span class="scheduling-instructions" v-if="form.type === item.value"> {{ $t(item.warn) }}</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 班次设置 form.type(规定打卡时间) === '1'展示 -->
        <el-form-item v-if="form.type === '1'" :label="$t('555')" prop="week_info" key="week_info">
          <el-col>
            <p>
              <strong>{{ $t('1368') }}：</strong>
              <span>{{ default_shift.name }}</span>
              {{ form.shift_start }} ~ <label v-if="form.end_mark">{{ form.end_mark }}</label> {{ form.shift_end }}
              <!-- 更换 -->
              <el-button type="text" @click="openSch(null)">{{ $t('557') }}</el-button>
            </p>
          </el-col>
          <!-- 时间设置 -->
          <el-col>
            <el-table
              @select-all="handleSelectAll"
              @select="handleSelect"
              @selection-change="handleSelectionChange"
              ref="table"
              :data="tableData"
              border
              style="width: 100%; margin-top: 10px; max-width: 550px"
            >
              <el-table-column type="selection" width="65"></el-table-column>
              <el-table-column fixed="right" :label="$t('558')" prop="label" width="120"></el-table-column>
              <!-- 班次时间 -->
              <el-table-column fixed="right" :label="$t('546')">
                <template slot-scope="scope"
                  >{{ scope.row.shift_name }} {{ scope.row.start_time }} ~
                  <label v-if="scope.row.end_mark">{{ scope.row.end_mark }}</label> {{ scope.row.end_time }}
                </template>
              </el-table-column>
              <el-table-column fixed="right" :label="$t('843')" width="120">
                <template slot-scope="scope"
                  ><el-button type="text" @click="openSch(scope.$index, scope.row)">{{ $t('557') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-form-item>
        <template v-if="form.type === '2' || form.type === '3'">
          <!-- 打卡时段 -->
          <el-form-item :label="$t('1390')" prop="shift_end" key="shift_start">
            <el-time-picker v-model="form.shift_start" style="width: 120px" format="HH:mm" value-format="HH:mm">
            </el-time-picker>
            <span> ~ </span>
            <el-time-picker v-model="form.shift_end" style="width: 120px" format="HH:mm" value-format="HH:mm">
            </el-time-picker>
            <!-- 次日标签 -->
            <el-tag v-if="isNextDay.isViewNextDay" class="margin-left">
              {{ $t('1592') }}
            </el-tag>
          </el-form-item>
          <!-- 工作日设置 -->
          <el-form-item :label="$t('1396')" prop="type" key="week">
            <el-checkbox-group v-model="week">
              <el-checkbox v-for="(item, index) in weekArr" :label="index + 1" :key="index">{{ $t(item) }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
        <template v-if="!['4', '3', '2', '1'].includes(form.type)">
          <!-- 上班打卡规则 -->
          <el-form-item :label="$t('1303')" prop="on_min_ago" key="on_min_ago">
            <p>
              {{ $t('1300') }}
              <el-input v-enterIntNumber class="my-input" v-model="form.on_min_ago" v-enterNumberMax="450" />
              {{ $t('1302') }}
            </p>
          </el-form-item>
          <!-- 下班打卡规则 -->
          <el-form-item :label="$t('1304')" prop="off_min_later" key="off_min_later">
            <p>
              {{ $t('1301') }}
              <el-input v-enterIntNumber class="my-input" v-model="form.off_min_later" v-enterNumberMax="720" />
              {{ $t('1302') }}
            </p>
          </el-form-item>
        </template>
        <!-- 考勤计算规则 -->
        <el-form-item :label="$t('5008')" prop="one_day_hour" key="one_day_hour">
          <!-- 每日至少工工作xxx小时记为全勤(0-24)，可以保留一位小数 -->
          <p>
            {{ $t('5000') }}
            <el-input
              type="number"
              class="my-input"
              v-model="form.one_day_hour"
              v-enterNumberPoint1
              v-enterNumberMax="24"
            />
            {{ $t('5007') }}
          </p>
        </el-form-item>
        <el-form-item prop="half_day_hour" key="half_day_hour">
          <!-- 每日至少工工作xxx小时记为半日(0-24)，可以保留一位小数 -->
          <p>
            {{ $t('5000') }}
            <el-input
              type="number"
              class="my-input"
              v-model="form.half_day_hour"
              v-enterNumberPoint1
              v-enterNumberMax="24"
            />
            {{ $t('5005') }}
          </p>
        </el-form-item>
        <!-- 设置节假日时间 -->
        <el-form-item :label="$t('845')">
          <el-checkbox v-model="checked">
            {{ $t('570') }}
            <!-- 公共假日 -->
            <el-form-item prop="holiday_setting_id" class="inline">
              <el-select
                v-model="form.holiday_setting_id"
                :placeholder="$t('221')"
                style="width: 304px"
                :disabled="!checked"
                popper-class="holiday-select"
              >
                <el-option v-for="item in holidaySettings" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            {{ $t('575') }}
            <el-button type="text" @click="handleViewDetail" v-if="form.holiday_setting_id && checked">{{
              $t('1850')
            }}</el-button>
          </el-checkbox>
        </el-form-item>
        <!-- 选择办公地点 -->
        <el-form-item :label="$t('534')" prop="area_setting" v-if="form.type !== '3'" key="area_setting">
          <p style="margin: 0 20px" v-for="(item, index) in area" :key="index">
            <i
              class="el-icon-location"
              style="font-size: 22px; color: rgb(214, 33, 25); margin-right: 7px; transform: translateY(3px)"
            ></i>
            <span> {{ item.area_name ? item.area_name : item.name }}({{ $t('581', { key: item.range }) }}) </span>
          </p>
          <br />
          <el-button type="primary" plain icon="el-icon-plus" @click="showMap">
            {{ $t('567') }}
          </el-button>
        </el-form-item>
        <!-- 开启人脸识别打卡 -->
        <el-form-item :label="$t('1351')" v-if="form.type !== '3'" :key="'a3'">
          <el-checkbox v-model="form.is_on_face">{{ $t('1352') }}</el-checkbox>
        </el-form-item>
        <!-- 人脸打卡方式 -->
        <el-form-item v-if="form.is_on_face" class="face-form-item" key="face_method">
          <el-radio-group v-model="form.face_method">
            <el-radio :label="1">{{ $t('1353') }}</el-radio>
            <el-radio :label="2">{{ $t('1354') }} </el-radio>
          </el-radio-group>
          <el-tooltip :content="$t('1356')" placement="top">
            <img class="face-tips" src="@/assets/img/icon-question.png" alt="" />
          </el-tooltip>
        </el-form-item>
        <!-- 外勤打卡 -->
        <template v-if="form.type !== '3'">
          <el-form-item :label="$t('533')" prop="out_range" :key="'a2-1'">
            <el-radio-group v-model="form.out_range">
              <el-radio label="1">{{ $t('577') }}</el-radio>
              <el-radio label="2">{{ $t('578') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.out_range === '1'" prop="out_range_hide_address" :key="'a2'">
            <template slot="label">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="width: 120px">{{ $t('1442') }}</div>
                <i class="el-icon-warning-outline" />
              </el-tooltip>
              {{ $t('1441') }}
            </template>
            <el-radio-group v-model="form.out_range_hide_address">
              <el-radio label="1">{{ $t('577') }}</el-radio>
              <el-radio label="2">{{ $t('578') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <el-form-item :label="$t('i18n.c470ef5730b648b3b6b871552b745be0')" prop="is_business">
          <el-radio-group v-model="form.is_business">
            <el-radio :label="1">{{ $t('577') }}</el-radio>
            <el-radio :label="0">{{ $t('578') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.is_business === 1">
          <el-form-item prop="is_business_click" key="is_business_click">
            <template slot="label">
              <span style="vertical-align: middle">{{ $t('i18n.d64a7b3cb82a406b84fcf46fe12b8dfc') }}</span>
              <el-tooltip effect="dark" :content="$t('i18n.8fc0539e951c42caa4efd901e8c9142d')" placement="top">
                <img class="icon_doubt" src="~@/assets/img/icon_doubt.png" />
              </el-tooltip>
            </template>
            <el-radio-group v-model="form.is_business_click">
              <el-radio :label="1">{{ $t('i18n.13005-1') }}</el-radio>
              <el-radio :label="0">{{ $t('i18n.13005-2') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <!-- 考勤生效时间 -->
        <el-form-item :label="$t('847')" prop="change_type" key="'a1'">
          <el-radio-group v-model="form.change_type" :disabled="!isDefault">
            <el-radio :label="1">{{ $t('538') }}</el-radio>
            <el-radio :label="2">{{ $t('537') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex-btn">
      <el-button size="small" @click="$emit('doSubmit', null, 1)" :disabled="loading">{{ $t('66') }}</el-button>
      <el-button size="small" type="primary" @click="handleEditSettings" :loading="loading">
        {{ form.type === '4' ? $t('1734') : $t('67') }}
      </el-button>
    </div>
    <!-- 地图 -->
    <my-map @changeMap="changeMap" ref="map" :area="area" />
    <!-- 班次选择 -->
    <select-sch ref="selectSch" @change="schSelect" :p="p" />
    <!-- 公共假期查看 -->
    <common-holiday-modal ref="viewHoliday" :isView="true" :isEdit="true" />
  </div>
</template>

<script>
/* eslint-disable */
import { editSettings, getSettingInfo, addSetting, getHolidays, checkSupervisor } from 'api/Attendance'
import myMap from './map'
import framework from '_c/framework'
import org from '_c/organization'
import SelectSch from './select-scheduling'
import CommonHolidayModal from './common-holiday-modal'
import { axiosRequest } from '@/util/axios-request'

// 最大值限制
import '@/views/payroll/directive.js'

// 规则类型
const typeRules = [
  // 固定班制
  { value: '1', key: '1863', warn: '1865' },
  // 不固定班制
  { value: '2', key: '1864', warn: '1866' },
  // 排班
  { value: '4', key: '1728', warn: '1733' },
  // 不需要打卡
  { value: '3', key: '554', warn: '1867' }
]
// 表格数据格式化
// 一周翻译
const weekArr = ['559', '560', '561', '562', '563', '564', '565']
// 表格数据 循环生成
const tableData = self => {
  return weekArr.map((item, index) => {
    return {
      label: self.$t(item),
      value: index + 1,
      start_time: '',
      end_time: ''
    }
  })
}
let supervisorStaffIds = (rule, value, callback) => {
  if (!value.length) {
    return callback(new Error(rule.message))
  } else {
    callback()
  }
}

export default {
  props: {
    type: {
      type: Number,
      default: false
    },
    p: {
      type: String,
      default: ''
    }
  },
  components: {
    myMap,
    org,
    framework,
    SelectSch,
    CommonHolidayModal
  },
  data() {
    const areaSetting = (rule, value, callback) => {
      const { area_setting } = this.form
      if (!Array.isArray(area_setting) || area_setting.length < 1) {
        callback(new Error(this.$t('858')))
      } else {
        callback()
      }
    }
    // 公共假期校验
    const holidaySettingValid = (rule, value, callback) => {
      const { checked } = this
      if ((checked && value) || !checked) return callback()
      callback(new Error(this.$t('221')))
    }
    // 结束时间校验
    const shiftValid = (rule, value, callback) => {
      const { isSameTime } = this.isNextDay
      if (isSameTime) callback(new Error(this.$t('1919')))
      return callback()
    }
    return {
      // 考勤规则枚举
      typeRules,
      // 所选假期名称
      holidayTitle: '',
      // 周翻译
      weekArr,
      // 默认时间
      defaultDate: {
        start: new Date('', '', '', '9', '30', '0'),
        end: new Date('', '', '', '18', '0', '0')
      },
      orgVisible: false,
      orgVisibleLead: false,
      tableData: tableData(this),
      weekInfo: [], // 选中周信息
      // 法定节假日
      checked: null,
      holidaySettings: [], //公共假日options
      form: {
        type: '1',
        department_id: [],
        staff_info_ids: [],
        supervisor_staff_list: [],
        supervisor_staff_ids: [],
        off_min_later: '',
        on_min_ago: '',
        half_day_hour: '',
        one_day_hour: '',
        shift_start: '09:00', //打卡时段开始时间
        shift_end: '18:00', // 打卡时段结束时间
        is_on_face: false, // 是否开启人脸识别打卡，0不开启，1开启
        face_method: 2, // 人脸打卡方式，0不开启，1人脸打卡，2人脸打卡+活体检测
        week_info: [], // 工作日
        holiday_setting_id: '', // 公共假日ID
        out_range_hide_address: '2', // 允许外勤员工隐藏具体地点 1 允许 2 不允许
        is_business: undefined,
        is_business_click: undefined
      },
      rules: {
        name: [{ required: true, message: this.$t('547') }],
        supervisor_staff_ids: [
          { validator: supervisorStaffIds, required: true, message: this.$t('221'), trigger: ['blur', 'change'] }
        ],
        change_type: [{ required: true, message: this.$t('535') }],
        out_range: [{ required: true, message: this.$t('221') }],
        off_min_later: [{ required: true, message: this.$t('90') }],
        on_min_ago: [{ required: true, message: this.$t('90') }],
        half_day_hour: [{ required: true, message: this.$t('90') }],
        one_day_hour: [{ required: true, message: this.$t('90') }],
        shift_end: [{ validator: shiftValid }],
        shift_start: [{ validator: shiftValid }],
        area_setting: [
          {
            validator: areaSetting,
            trigger: 'change'
          }
        ],
        holiday_setting_id: [{ validator: holidaySettingValid }],
        face_method: [{ required: true, message: this.$t('1353') }],
        is_on_face: [{ required: true, message: this.$t('1353') }],
        out_range_hide_address: [{ required: true, message: this.$t('1353') }],
        is_business: [{ required: true, message: this.$t('221') }],
        is_business_click: [{ required: true, message: this.$t('221') }]
      },
      week: [],
      loading: false,
      options: [],
      radio: 3,
      value: '',
      holidayTitle: [{}],
      area: [],
      staffList: [],
      default_shift: {},
      default_supervisor: {}
    }
  },
  computed: {
    isDefault() {
      const s = !(this.form.is_default && this.form.is_default == 1)
      if (!s) this.form.change_type = 1
      return s
    },
    // 是否展示次日 是否提示开始时间不能等于结束时间
    // 当结束时间小于开始时间则显示次日
    isNextDay() {
      // '19:00' '15:32'
      const { shift_start, shift_end } = this.form
      const result = {
        isViewNextDay: false,
        isSameTime: false
      }
      if (!shift_start || !shift_end) return result
      const end = parseInt(shift_end.replace(':', ''))
      const start = parseInt(shift_start.replace(':', ''))
      // 判断结束时间是否小于开始时间
      result.isViewNextDay = end < start
      // 判断结束时间是否等于开始时间
      result.isSameTime = end === start
      return result
    }
  },
  watch: {
    visible(v) {
      if (!v) {
        this.tableData = tableData(this)
      }
    }
  },
  methods: {
    // 查看
    handleViewDetail() {
      this.$refs.viewHoliday.visible = true
      // 编辑获取详情
      this.$nextTick(() => {
        this.$refs.viewHoliday.holidayDetail(this.form.holiday_setting_id)
      })
    },
    // 表格默认选中
    tableSelect() {
      this.tableData.forEach(row => {
        if (row.checked) {
          this.$refs.table && this.$refs.table.toggleRowSelection(row, true)
        }
      })
      this.handlerWorkDays()
    },
    // 工作日默认选中
    handlerWorkDays() {
      this.weekInfo = this.form.week_info.map(item => {
        return Number(item.day)
      })
    },
    changeRadio(val) {
      const weekInfo = this.form.week_info
      this.week = weekInfo.map(item => Number(item.day))
      if (val === '1') this.tableSelect()
      if (val === '3' && this.type === 1) this.week = [1, 2, 3, 4, 5]
      // 自由班制的打卡时段设置：该时段为可以进行上下班打卡时段，而非班次时间。时段默认值为9-18，
      if (val === '2') {
        this.form.shift_start = '09:00'
        this.form.shift_end = '18:00'
      }
    },
    init(obj) {
      // 1 新建 2编辑
      if (this.type === 2) {
        const params = JSON.parse(JSON.stringify(obj))
        // 获取详情
        this.handleGetSettingInfo(params)
      } else {
        // 默认选中周一到周五
        this.tableData = this.tableData.map(item => {
          return {
            ...item,
            start_time: undefined,
            end_time: undefined,
            checked: item.value < 6 ? true : false
          }
        })
        this.$nextTick(() => this.tableSelect())
        // 获取公共假期列表
        // getHolidays().then(res => {
        //   this.holidaySettings = res.data
        //   // 默认选中的假期
        //   this.handleHolidayGet()
        // })
        axiosRequest({
          url: '/web/attendance/addSettingInfo',
          method: 'GET'
        }).then(res => {
          this.holidaySettings = res.data.holidays
          // 默认选中的假期
          this.handleHolidayGet()
          // 默认触发班次选中操作
          this.schSelect(res.data.default_shift)
          this.default_shift = res.data.default_shift || {}
          this.default_supervisor = JSON.parse(JSON.stringify(res.data.default_supervisor || {}))
          this.form.supervisor_staff_list = res.data.default_supervisor ? [res.data.default_supervisor] : []
          this.form.supervisor_staff_ids = res.data.default_supervisor ? [res.data.default_supervisor.staff_id] : []
        })
      }
      this.visible = true
    },
    // 获取默认公共假期
    handleHolidayGet() {
      const selectedHoliday = this.holidaySettings.filter(item => item.is_selected)[0]
      if (selectedHoliday) {
        this.form.holiday_setting_id = selectedHoliday.id
      }
    },
    // 初始化表格数据渲染
    handleGetSettingInfo(params) {
      const msg = {
        id: params.id
      }
      getSettingInfo(msg).then(res => {
        // 获取假期列表
        this.holidaySettings = res.data.holiday_setting
        // 默认选中的假期
        this.form = { ...this.form, ...res.data }
        // 公共假期值
        this.handleHolidayGet()
        this.checked = !!(this.form.is_holiday && this.form.is_holiday === '1')
        // 打卡日
        const weekInfo = res.data.week_info
        this.week = weekInfo.map(item => Number(item.day))
        // 格式化表格数据
        this.tableData = this.tableData.map((item, index) => {
          weekInfo.forEach(el => {
            if (Number(el.day) === item.value) {
              el.week = item.value
              item = { ...item, ...el }
              item.checked = true
            }
          })
          return item
        })
        // 打卡范围
        this.area = this.form.area_info || []
        // 默认选中
        this.form.staff_info_ids = this.form.staff_list
        this.form.supervisor_staff_ids = this.form.supervisor_staff_list
        this.staffList = this.form.staff_list
        // 班次表格默认选中
        this.$nextTick(() => {
          this.tableSelect()
        })
        // 人物数据选中
        const { department_list, staff_list, supervisor_staff_list } = this.form
        /**
         *  保存时所需参数
         *  department_id，staff_info_ids Examples[1,2,3]
         *  地理位置参数 area_setting
         */
        const { area_info } = this.form
        area_info &&
          (this.form.area_setting = area_info.map(item => {
            return {
              name: item.area_name,
              lng: item.area_lng,
              lat: item.area_lat,
              range: item.range
            }
          }))
        this.form.department_id = []
        this.form.staff_info_ids = []
        this.form.supervisor_staff_ids = []
        /**
         *  组织架构选择组件所需格式 默认选中
         *  部门：department_id  和  department_name
         *  人员：staff_id 和  staff_name
         */
        this.form.department_list = department_list.map(item => {
          this.form.department_id.push(item.id)
          item.department_id = item.id
          item.department_name = item.name
          return item
        })
        this.handleStaffList(staff_list, 'staff_info_ids', 'staff_list')
        this.handleStaffList(supervisor_staff_list, 'supervisor_staff_ids', 'supervisor_staff_list')
      })
    },
    handleStaffList(data, ids, list) {
      const staffs = []
      if (Array.isArray(data)) {
        data.forEach(item => {
          this.form[ids].push(item.id || item.staff_id)
          staffs.push({
            staff_id: item.staff_id || item.id,
            staff_name: item.staff_name || item.name,
            staff_name_en: item.staff_name_en,
            staff_name_secondary: item.staff_name_secondary,
            staff_name_th: item.staff_name_th || item.name,
            avatar_url: item.avatar_url,
            id: item.id,
            name: item.name
          })
        })
      }
      this.form[list] = staffs
    },
    departSel(a, b, c) {
      this.form.department_id = c
    },
    showMap() {
      this.$refs.map.visible = true
    },
    get_table_row_unchcek_item(item) {
      return {
        checked: false,
        label: item.label,
        value: item.value,
        start_time: undefined,
        end_time: undefined
      }
    },
    get_table_row_checked_item(item, shift_obj = {}) {
      return {
        ...item,
        checked: true,
        end_mark: shift_obj.end_mark,
        start_time: shift_obj.start,
        end_time: shift_obj.end,
        shift_name: shift_obj.name,
        shift_id: shift_obj.id
      }
    },
    // 当用户手动勾选全选 Checkbox 时触发的事件
    handleSelectAll(selection) {
      const cb = selection.length === 0 ? this.get_table_row_unchcek_item : this.get_table_row_checked_item
      this.tableData = this.tableData.map(item => (selection.length === 0 ? cb(item) : cb(item, this.default_shift)))
      this.$nextTick(() => {
        this.tableSelect()
      })
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    handleSelect(selection, row) {
      row.checked = !row.checked
      const index = this.tableData.findIndex(item => item.value === row.value)
      const value = row.checked
        ? this.get_table_row_checked_item(row, this.default_shift)
        : this.get_table_row_unchcek_item(row)
      this.$set(this.tableData, index, value)
      this.$nextTick(() => {
        const item = this.tableData[index]
        this.$refs.table.toggleRowSelection(item, item.checked)
      })
    },
    // 当选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.form.week_info = selection
    },
    addCloumn() {
      this.holidayTitle.push({})
    },
    // 打开班次设置
    openSch(params, row) {
      const id = row ? row.shift_id : this.default_shift.id
      this.$refs.selectSch.updateCurrentShiftId(id)
      this.$refs.selectSch.init(params)
    },
    update_default_shfit(value) {
      this.default_shift = value
    },
    // 班次选中操作
    schSelect(params) {
      const { index, start, end, name, id, end_mark } = params
      // 只针对快捷设置的更改
      if (index === null) {
        this.update_default_shfit(params)
      }
      // 修改全部 index参数不存在时且不含有0则修改全部 反之相反
      if (!index && index !== 0) {
        this.form.shift_start = start
        this.form.shift_end = end
        this.form.end_mark = end_mark
        this.tableData = this.tableData.map(item => {
          if (item.value < 6) {
            return this.get_table_row_checked_item(item, params)
          } else {
            return this.get_table_row_unchcek_item(item)
          }
        })
      } else {
        const item = this.tableData[index]
        this.$set(this.tableData, index, {
          ...item,
          checked: true,
          start_time: start,
          end_time: end,
          shift_name: name,
          shift_id: id,
          end_mark
        })
      }
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          if (item.checked) this.form.week_info.push(item)
        })
        this.tableSelect()
      })
    },
    changeMap(obj) {
      this.$set(this.form, 'area_setting', obj ? obj : this.form.area_setting)
      this.area = obj || []
    },
    // 编辑群组保存请求
    handleEditSettings() {
      const { one_day_hour, half_day_hour } = this.form
      if (Number(one_day_hour) < Number(half_day_hour)) {
        return this.$notify({
          title: this.$t('229'),
          message: this.$t('1401'),
          type: 'warning'
        })
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          const { type, week_info, week } = this.form
          const obj = week_info || []
          const status = type === '1'
          /**
           *    根据考勤规则判断  form.type 不同的类型传不同的参数
           *    1. 规定打卡时间 则过滤没有打卡时间的
           *    2. 不限制打卡时间则可以选中 时间可不传
           *    3. 不需要打卡则不需要次想操作
           *    4. 排班
           */
          let arr = []
          // 需要打卡则生成week_setting
          if (type === '1') {
            obj.map(item => {
              const msg = { week: item.value }
              const start = item.start_time
              const end = item.end_time
              const shift_id = item.shift_id
              start && (msg.start = start.split(' ').slice(-1)[0])
              end && (msg.end = end.split(' ').slice(-1)[0])
              shift_id && (msg.shift_id = shift_id)
              msg.rest_end = item.rest_end
              msg.rest_start = item.rest_start
              if ((status && start && end && shift_id) || this.form.type === '2') arr.push(msg)
            })
          }
          if (type === '2' || type === '3') {
            arr = this.week.map(item => {
              return {
                week: item
              }
            })
          }
          // 不限制打卡时间
          this.form.is_holiday = this.checked ? 1 : 2
          // 需要打卡则传递该打卡信息
          this.form.week_setting = arr
          // 数组降纬
          if (this.form.staff_info_ids) {
            this.form.staff_info_ids = this.form.staff_info_ids.flat()
          }
          // 不需要打卡是则传递这些参数
          if (this.form.type && this.form.type === '3') {
            const msg = {
              name: this.form.name,
              department_id: this.form.department_id,
              staff_info_ids: this.form.staff_info_ids,
              supervisor_staff_ids: this.form.supervisor_staff_ids,
              type: this.form.type,
              change_type: this.form.change_type,
              is_holiday: this.form.is_holiday,
              week_setting: this.form.week_setting,
              shift_start: this.form.shift_start,
              shift_end: this.form.shift_end,
              half_day_hour: this.form.half_day_hour,
              one_day_hour: this.form.one_day_hour,
              id: this.form.id,
              holiday_setting_id: this.form.holiday_setting_id,
              is_business: this.form.is_business,
              is_business_click: this.form.is_business_click
            }
            this.form = msg
          }
          const requestMethods = this.type === 1 ? addSetting : editSettings // 编辑或新建接口
          const toTargetType = this.form.type === '4' ? 3 : 1 // 根据type来判断保存之后是否跳转到排班
          this.loading = true // 防重复点击
          // 参数请求
          requestMethods(this.form)
            .then(res => {
              this.$emit('doSubmit', { id: this.form.id || res.data.id }, toTargetType)
              this.$parent.handleGetAttendanceSettingList()
            })
            .finally(() => (this.loading = false))
        }
      })
    },
    leadStaffList() {
      let staffName = ''
      let list = this.form.supervisor_staff_list || []
      if (list.length) {
        list.forEach((item, index) => {
          if (list.length - 1 === index) {
            staffName += item.staff_name
          } else {
            staffName += item.staff_name + ', '
          }
        })
      }
      return staffName
    },
    handleLeadDepart(params) {
      const ids = this.form.supervisor_staff_ids
      const list = this.form.supervisor_staff_list
      // 校验已选成员是否包含当前登录账号人员（当前登录账号为主管理员无须校验）
      checkSupervisor({
        supervisor_staff_ids: params.staffIds
      }).then(({ data }) => {
        if (data && !data.check_result) {
          if (!params.staffIds.includes(this.default_supervisor.staff_id)) {
            this.$confirm(this.$t('2b876c04'), this.$t('229'), {
              confirmButtonText: this.$t('419'),
              cancelButtonText: this.$t('66'),
              type: 'warning'
            })
              .then(() => {
                this.form.supervisor_staff_ids = params.staffIds
                this.form.supervisor_staff_list = params.staff_list
                this.orgVisibleLead = false
              })
              .catch(() => {
                this.form.supervisor_staff_ids = ids
                this.form.supervisor_staff_list = list
              })
          }
        } else {
          this.form.supervisor_staff_ids = params.staffIds
          this.form.supervisor_staff_list = params.staff_list
          this.orgVisibleLead = false
        }
      })
    },
    // 选择成员
    handleSelectDepart(params) {
      this.form.department_id = this.formateList(params.dept_list, 'department_id')
      this.form.staff_info_ids = this.formateList(params.staff_list, 'staff_id')
      this.form.department_list = params.dept_list
      this.form.staff_list = params.staff_list
    },
    // 数据格式化
    formateList(obj, key) {
      return obj.map(item => item[key])
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  overflow: hidden;
}
.el-form {
  color: #606266;
  /deep/ .el-form-item__content {
    .my-radio {
      position: relative;
      .scheduling-instructions {
        display: block;
        position: absolute;
        bottom: -15px;
        font-size: 12px;
        left: 29px;
        color: #909399;
      }
    }
    .el-input {
      width: 100%;
      max-width: 304px;
      // height: 32px;
      // input {
      //   height: 32px;
      // }
    }
    .el-select {
      .el-input {
        height: 32px;
        input {
          height: 32px;
        }
      }
    }
  }
  /deep/ .face-form-item .el-form-item__content {
    display: flex;
    align-items: flex-end;
  }
  .face-tips {
    width: 20px;
    margin-left: 10px;
    cursor: pointer;
  }
  .my-input {
    width: 100px !important;
  }
}

.el-icon-arrow-left {
  cursor: pointer;
}

.icon_doubt {
  width: 18px;
  margin-left: 5px;
  vertical-align: middle;
}
</style>
<style lang="scss">
.holiday-select {
  max-width: 500px;
}
</style>
